export const setoresInitialState = {
  setores: [],
  setor: {},
  setorApagado: {},
  setorAdicionado: {},
  setorEditado: {},
};
